module.exports = __webpack_public_path__ + "static/media/realtors-icon-4.0ed59320.svg";